import React from "react";
import TextField from "@mui/material/TextField";
import styled from "@mui/material/styles/styled";
import Collapse from "@mui/material/Collapse";
import FormHelperText from "@mui/material/FormHelperText";

/**
 * V2 copies of the prod CssTextField components, re-colored with the v2 CSS
 * custom properties so they theme with [data-theme] on .bdrv2-root. MUI
 * styled() colors can't be overridden by namespaced CSS, so these are copies
 * (the prod files keep their hardcoded neon green).
 *
 * Accent-as-text uses var(--v2-accent-text) which is WCAG-safe per theme
 * (darkened emerald on light, bright green on dark).
 */

// Standard (underline) variant — name/email/city/phone fields
export const CssTextFieldStandardV2 = styled(TextField)({
  "& label": { color: "var(--v2-accent-text)" },
  "& label.Mui-focused": { color: "var(--v2-accent-text)" },
  "& .MuiInput-underline:before": {
    borderBottomColor: "var(--v2-border-strong)",
  },
  "& .MuiInput-underline:after": { borderBottomColor: "var(--v2-accent)" },
  "& .MuiInput-root:hover:before": {
    borderBottom: "2px solid var(--v2-accent-text)",
  },
  "& .MuiInputBase-input": {
    color: "var(--v2-field-text)",
    caretColor: "var(--v2-accent-text)",
  },
  "& .MuiInputBase-input::placeholder": {
    color: "var(--v2-text-faint)",
    opacity: 1,
  },
});

// Outlined variant — the "Other" free-text field
export const CssTextFieldOutlineV2 = styled(TextField)({
  "& label": { color: "var(--v2-accent-text)" },
  "& label.Mui-focused": { color: "var(--v2-accent-text)" },
  "& .MuiOutlinedInput-root": {
    color: "var(--v2-field-text)",
    backgroundColor: "var(--v2-field-bg)",
    borderRadius: "10px",
    "& fieldset": { borderColor: "var(--v2-border-strong)" },
    "&:hover fieldset": { borderColor: "var(--v2-accent-text)" },
    "&.Mui-focused fieldset": { borderColor: "var(--v2-accent)" },
  },
});

// Themed helper text (validation messages)
export function MyFormHelperTextV2({ formError, errorText, noBG }) {
  return (
    <Collapse timeout={500} in={formError}>
      <FormHelperText
        component={"div"}
        className={noBG ? "bdrv2-helper noBG" : "bdrv2-helper"}
      >
        {errorText}
      </FormHelperText>
    </Collapse>
  );
}
